

<!--<app-main-header></app-main-header>
<app-main-sidebar></app-main-sidebar>
<app-content-wrapper></app-content-wrapper>
<app-control-sidebar></app-control-sidebar>
<app-main-footer></app-main-footer>
<router-outlet></router-outlet>
  <app-main-header></app-main-header>
  -->


<div class="app-component app-container" [class.sidebar-mobile-open]="isUserLoggedIn && sidebarOpen">

  <!-- Impersonation banner: visible whenever an admin is proxied in as another user -->
  <div *ngIf="isImpersonating" class="impersonation-banner">
    <span class="impersonation-banner-text">
      <i class="fa fa-user-secret" aria-hidden="true"></i>
      You are logged in as <strong>{{ impersonatedUserName }}</strong>.
      Return to <strong>{{ impersonatorName }}</strong> when finished.
    </span>
    <button type="button" class="btn btn-sm btn-light impersonation-banner-btn" (click)="stopImpersonation()">
      <i class="fa fa-sign-out" aria-hidden="true"></i> Return to admin
    </button>
  </div>

  <nav class="main-header navbar navbar-expand navbar-white navbar-light fixed-top">
    <!-- Hamburger: only shown on small screens (CSS), toggles the off-canvas sidebar -->
    <button *ngIf="isUserLoggedIn" type="button" class="navbar-hamburger" (click)="toggleSidebar()"
            [attr.aria-expanded]="sidebarOpen" aria-label="Toggle navigation menu">
      <i class="fa" [ngClass]="sidebarOpen ? 'fa-times' : 'fa-bars'"></i>
    </button>
    <ul *ngIf="isUserLoggedIn" class="navbar-nav ms-auto align-items-center">
      <li class="nav-item topbar-user" *ngIf="isUserLoggedIn">
        <span class="topbar-welcome">{{'app.Welcome' | translate}}</span>
        <span class="topbar-name">{{fullName}}</span>
      </li>
      <li class="nav-item">
        <a class="nav-link topbar-logout" href="javascript:;" (click)="logout()">
          <i class="fa fa-sign-out"></i> {{'mainMenu.Logout' | translate}}
        </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->

 

  <div class="container-xl px-md-3 px-xxl-4">
    
    <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target=".menuItemsContainer">
      <span class="navbar-toggler-icon"></span>

    </button>

    <!-- Main Sidebar Container -->
    <aside *ngIf="isUserLoggedIn" class="main-sidebar main-sidebar-custom">

      <a routerLink="" class="brand-link">
        <span class="brand-icon"><i class="fas fa-circle-nodes"></i></span>
        <span class="brand-text">BRIDGE</span>
      </a>

      <!-- Sidebar -->
      <div class="sidebar">
        <!-- Sidebar user (optional) -->
        <!-- Sidebar Menu -->
        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false" (click)="closeSidebar()">
                <!-- Add icons to the links using the .nav-icon class
    with font-awesome or any other icon font library -->

                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="nav-link" routerLink="">
                        <i class="nav-icon fas fa-tachometer-alt"></i>
                        <p>
                            Home
                            <span class="badge badge-info right"></span>
                        </p>

                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/icdreport">

                        <i class="nav-icon fab fa-dochub"></i>
                        <p>
                            Distributors
                            <span class="badge badge-info right"></span>
                        </p>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/campaignparticipation">

                        <i class="nav-icon  fab fa-pinterest-p "></i>
                        <p>
                            Participation
                            <span class="badge badge-info right"></span>
                        </p>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/campaignmaster">

                        <i class="nav-icon  fab fa-cuttlefish"></i>
                        <p>
                            Campaigns
                            <span class="badge badge-info right"></span>
                        </p>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/changerequest">

                        <i class="nav-icon fas fa-registered"></i>
                        <p>
                            Requests
                            <span class="badge badge-info right"></span>
                        </p>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active" *ngIf="isHubUser">
                    <a class="nav-link" routerLink="/hubreportupload">

                        <i class="nav-icon fas fa-file-upload"></i>
                        <p>
                            LT Report Upload
                            <span class="badge badge-danger right" [class.report-badge-flash]="hubReportUrgent" *ngIf="hubReportDue" title="This week's report is due">Due</span>
                        </p>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/help">

                        <i class="nav-icon fas fa-question-circle"></i>
                        <p>
                            Help
                            <span class="badge badge-info right"></span>
                        </p>
                    </a>
                </li>

                <!--<li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/scpayments">

                        <i class="nav-icon fas fa-dollar-sign"></i>
                        <p>
                            SC Payments
                            <span class="badge badge-info right"></span>
                        </p>
                    </a>
                </li>-->
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/netsuiteledger">

                        <i class="nav-icon fas fa-chart-bar"></i>
                        <p>
                            Security Ledger Report
                            <span class="badge badge-info right"></span>
                        </p>
                    </a>
                </li>

               


                <!--<li class="nav-item" routerLinkActive="active">
      <a class="nav-link" routerLink="/admin-query">

        <i class="nav-icon fas fa-robot"></i>
        <p>
          AI Admin Agent
          <span class="badge badge-secondary right">AI</span>
        </p>

      </a>
    </li>-->

                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/settings">


                        <i class="nav-icon fa fa-cog"></i>
                        <p>
                            Settings

                            <span class="badge badge-info right"></span>

                        </p>


                    </a>
                </li>

            </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
      <!-- /.sidebar-custom -->
    </aside>

    <!-- Backdrop for the mobile off-canvas sidebar; tap to dismiss -->
    <div *ngIf="isUserLoggedIn" class="sidebar-backdrop" (click)="closeSidebar()"></div>


    <div *ngIf="isUserLoggedIn" class="collapse navbar-collapse menuItemsContainer">
      <!--<ul class="nav nav-pills flex-column flex-lg-row flex-fill">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" routerLink=""><i class="fa fa-home"></i></a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="canViewCustomers">
          <a class="nav-link" routerLink="/customers">{{'mainMenu.Customers' | translate}}</a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="canViewProducts">
          <a class="nav-link" routerLink="/products">{{'mainMenu.Products' | translate}}</a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="canViewOrders">
          <a class="nav-link" routerLink="/orders">{{'mainMenu.Orders' | translate}}</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/about">{{'mainMenu.About' | translate}}</a>
        </li>
        <li class="nav-item ms-lg-auto me-lg-2" routerLinkActive="active">
          <a class="nav-link" routerLink="/settings"><i class="fa fa-cog"></i></a>
        </li>
      </ul>-->

    </div>

    <div *ngIf="!isUserLoggedIn" class="collapse navbar-collapse menuItemsContainer">
      <ul class="nav nav-pills flex-column flex-lg-row ms-auto">
        <li class="nav-item" routerLinkActive="active">
          <a *ngIf="router.isActive('/about', false); else aboutPageNavTemplate" class="nav-link" routerLink="/login"><i class="fa fa-sign-in"></i></a>

        </li>
      </ul>
    </div>
  </div>
  <div id="pre-bootstrap" *ngIf="!isAppLoaded" class="prebootStep prebootShow">
    <div class="messaging">


    </div>
  </div>

  <main class="container-xl px-3 px-md-4 px-xxl-5">
    <router-outlet></router-outlet>
    <div class="footer-height"></div>
  </main>

  <!-- Global AI Form Assistant Panel (visible on any form page) -->
  <app-ai-hint-panel *ngIf="showAiPanel"></app-ai-hint-panel>

  <footer class="footer fixed-bottom">
    <div class="container">
      <p class="text-center text-muted">
        <span style="font-style:italic">BRIDGE</span> &copy; {{getYear()}}
      </p>
    </div>
  </footer>

  <div *ngIf="shouldShowLoginModal" class="modal fade login-control" bsModal #loginModal="bs-modal" (onShown)="onLoginModalShown()" (onHidden)="onLoginModalHidden()" (onHide)="onLoginModalHide()"
       [config]="{backdrop: 'static'}" tabindex="-1">
    <div class="modal-dialog modal-lg h-75 d-flex flex-column justify-content-center my-0">
      <div class="modal-content">
        <div class="modal-body">
          <app-login #loginControl isModal="true"></app-login>
        </div>
      </div>
    </div>
  </div>

</div>
